<rt-admins-select-dialog-form
  [heading]="heading"
  [subheading]="subheading"
  [assignments]="assignments"
  [lockedAssignments]="lockedAssignments"
  [lockedAssignmentsTooltip]="lockedAssignmentsTooltip"
  [preventAdminRemove]="preventAdminRemove"
  [admins]="allowedUsers"
  [disallowedUsers]="disallowedUsers"
  [currentAdminId]="currentAdminId"
  [showCountBeforeSubheading]="showCountBeforeSubheading"
  [minSelectedAdmins]="minSelectedAdmins"
  [maxSelectedAdmins]="maxSelectedAdmins"
  [inviteModeEnabled]="inviteModeEnabled"
  [disabledUserCopy]="disabledUserCopy"
  [disabledUsersHeader]="disabledUsersHeader"
  [actionLabel]="actionLabel"
  [hasActionLabelCount]="hasActionLabelCount"
  (cancelClick)="cancel()"
  (submitClick)="submit($event)"
>
</rt-admins-select-dialog-form>
